import i18n from "../../i18n";


export const localizedOptions = (
    key: string,
    options: { [name: string]: string }
): { [name: string]: string } => {
    const translated = (i18n.getResource(i18n.language, "elements", `enum.${key}`)
        ?? {}) as { [name: string]: string };

    const keys = [
        ...Object.keys(translated).filter((k) => k in options),
        ...Object.keys(options).filter((k) => !(k in translated)),
    ];

    return Object.fromEntries(keys.map((k) => [k, translated[k] ?? options[k]]));
};
